import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MandatoryChecksTemplatesComponent } from './pages/mandatory-checks-templates/mandatory-checks-templates.component';
import {
  ASSIGNMENTS_ROUTE,
  BUSINESS_UNITS_ROUTE,
  DELIVERABLE_TEMPLATES_ROUTE,
  MANDATORY_CHECKS_TEMPLATES_ROUTE,
  PEER_POOL_DISCIPLINES_ROUTE,
  RISK_ASSESSMENT_ROUTE,
} from '../../_shared-by-role/global-settings/global-settings.constants';
import { PeerPoolDisciplinesComponent } from './pages/peer-pool-disciplines/peer-pool-disciplines.component';
import { DeliverableTemplatesComponent } from './pages/deliverable-templates/deliverable-templates.component';
import { BusinessUnitsComponent } from './pages/business-units/business-units.component';
import { RiskAssessmentConfigComponent } from './pages/risk-assessment-configs/risk-assessment-configs.component';
import { AssignmentsDashboardComponent } from './pages/assignments-dashboard/assignments-dashboard.component';

const routes: Routes = [
  {
    path: BUSINESS_UNITS_ROUTE,
    component: BusinessUnitsComponent,
    children: [],
  },
  {
    path: MANDATORY_CHECKS_TEMPLATES_ROUTE,
    component: MandatoryChecksTemplatesComponent,
    children: [],
  },
  {
    path: PEER_POOL_DISCIPLINES_ROUTE,
    component: PeerPoolDisciplinesComponent,
    children: [],
  },
  {
    path: DELIVERABLE_TEMPLATES_ROUTE,
    component: DeliverableTemplatesComponent,
    children: [],
  },
  {
    path: RISK_ASSESSMENT_ROUTE,
    component: RiskAssessmentConfigComponent,
    children: [],
  },
  {
    path: ASSIGNMENTS_ROUTE,
    component: AssignmentsDashboardComponent,
    children: [],
  },
  {
    path: ASSIGNMENTS_ROUTE,
    component: AssignmentsDashboardComponent,
    children: [],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes), CommonModule],
  exports: [RouterModule],
})
export class GlobalSettingsDAEngineerRoutingModule {}
